const hasAllowAllCookie = () => {
  try {
    return document.cookie.indexOf("allowAll") !== -1;
  } catch (error) {
    console.error(error);
    return false;
  }
};

const hasAllowAllParam = () => {
  try {
    return (
      window.location.search.indexOf("allowAll") !== -1 ||
      window.location.search.indexOf("allowall") !== -1 ||
      window.location.search.indexOf("allow_all") !== -1
    );
  } catch (error) {
    console.error(error);
    return false;
  }
};

let allowInternal = false;
if (hasAllowAllParam()) {
  allowInternal = true;
  console.log("Allowing internal parners via cookie");
  document.cookie = "allowAll=true;path=/";
} else if (hasAllowAllCookie()) {
  allowInternal = true;
  console.log("Allowing internal parners");
}

const allHapiConfig = [
  {
    name: "Acceptance",
    accounts: [
      {
        name: "Demo - Acceptance",
        apiBaseUrl: "https://marketplace.web-acceptance.vonq-aws.com/",
        pkbBaseUrl: "https://pkb.web-acceptance.vonq-aws.com/",
        token: "4c905f17-8084-4972-9035-20365399b6a7",
        partnerId: "cfc8430f-a7ec-404d-8f35-076c80c640a8",
        internal: false
      },
      {
        name: "Demo PKB Wallets - Acceptance",
        apiBaseUrl: "https://marketplace.web-acceptance.vonq-aws.com/",
        pkbBaseUrl: "https://pkb.web-acceptance.vonq-aws.com/",
        token: "e3000d14-bd1a-4c10-9927-b823450496e1",
        partnerId: "6d5112aa-7ebe-4e9c-9eb5-8486c925297e",
        internal: true
      },
      {
        name: "Demo PKB Wallets AUD - Acceptance",
        apiBaseUrl: "https://marketplace.web-acceptance.vonq-aws.com/",
        pkbBaseUrl: "https://pkb.web-acceptance.vonq-aws.com/",
        token: "8514a98d-247f-4808-aa62-005922f70181",
        partnerId: "8514a98d-247f-4808-aa62-005922f70181",
        internal: true
      },
      {
        name: "Demo Pricing V2 - Acceptance",
        apiBaseUrl: "https://marketplace.web-acceptance.vonq-aws.com/",
        pkbBaseUrl: "https://pkb.web-acceptance.vonq-aws.com/",
        token: "dcc49915-e7aa-4766-aa04-8ebb162d5293",
        partnerId: "8a6aab4d-e941-4854-b3dc-b77b511bbb6e",
        internal: true
      },
      {
        name: "Demo - Acceptance - PROD Delivery",
        apiBaseUrl: "https://marketplace.web-acceptance.vonq-aws.com/",
        pkbBaseUrl: "https://pkb.web-acceptance.vonq-aws.com/",
        token: "f2f1ee10-a778-4aa7-a090-2a8e6d181733",
        partnerId: "58a911b0-e004-45b8-a153-8d6ab31a1466",
        internal: true
      }
    ]
  },
  {
    name: "Sandbox",
    accounts: [
      {
        name: "APITEAM - Sandbox",
        apiBaseUrl: "https://marketplace-sandbox.api.vonq.com/",
        pkbBaseUrl: "https://pkb-sandbox.web-production.vonq-aws.com/",
        token: "0a73f489-58a6-4b2d-adef-3e40d6a4250a",
        partnerId: "cfc8430f-a7ec-404d-8f35-076c80c640a8",
        internal: false
      },
      {
        name: "Demo PKB Wallets - Sandbox",
        apiBaseUrl: "https://marketplace-sandbox.api.vonq.com/",
        pkbBaseUrl: "https://pkb-sandbox.web-production.vonq-aws.com/",
        token: "66b2e921-8cdf-43ee-86df-2444e7628175",
        partnerId: "ba6822f3-16bc-48b0-b7a0-b812f2a71a61",
        internal: true
      }
    ]
  },
  {
    name: "Production",
    accounts: [
      {
        name: "APITEAM - Production",
        apiBaseUrl: "https://marketplace.api.vonq.com/",
        pkbBaseUrl: "https://pkb.web-production.vonq-aws.com/",
        token: "2795ab80-bb9c-420b-924b-46864b6f7dd2",
        partnerId: "cfc8430f-a7ec-404d-8f35-076c80c640a8",
        internal: false
      }
    ]
  }
];

export const hapiConfig = [];
for (let i = 0; i < allHapiConfig.length; i++) {
  const env = allHapiConfig[i];
  const envConfig = { ...env, accounts: [] };

  const accounts = env.accounts.filter(
    account => allowInternal || !account.internal
  );
  envConfig.accounts = accounts;
  hapiConfig.push(envConfig);
}

if (process.env.VUE_APP_LOCAL_ENV_NAME) {
  const name = process.env.VUE_APP_LOCAL_ENV_NAME;
  hapiConfig.push({
    name: "Local",
    accounts: [
      {
        name: name.charAt(0).toUpperCase() + name.slice(1),
        apiBaseUrl: process.env.VUE_APP_LOCAL_ENV_BASE_URL,
        token: process.env.VUE_APP_LOCAL_ENV_TOKEN,
        partnerId: process.env.VUE_APP_LOCAL_ENV_PARNER_ID
      }
    ]
  });
}
